import PaymentDocuemnts from './PaymentDocuments';

export default PaymentDocuemnts;
